const axios = require('axios');
const Sentry = require('@sentry/browser');
const config = require('../../config');

const api = axios.create({
  baseURL: `${config.api_url}`,
  timeout: 20000,
  headers: {
    'content-type': 'application/json',
  },
});

api.interceptors.request.use((req) => {
  req.headers['x-api-key'] = config.carbon_app_api_key;
  return req;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const requestEndpoint = `${err.config.method.toUpperCase()} ${
      err.config.baseURL
    }${err.config.url}`;
    let error;
    if (err.response) {
      if (err.response.data) {
        if (
          err.response.data.errors?.length &&
          err.response.data.errors.every(
            (e) => e['developer_message'] && e.code,
          )
        ) {
          error = JSON.stringify(
            err.response.data.errors.map(
              (e) => e.code + ' - ' + e['developer_message'],
            ),
          );
        } else {
          error = JSON.stringify(err.response.data);
        }
      } else {
        error = err.response.status + ' ' + err.response.statusText;
      }
    } else {
      error = err.message;
    }
    const fullMessage = `${requestEndpoint} ERROR: ${error}`;
    console.warn('The following message was sent to Sentry: \n' + fullMessage);
    Sentry.captureMessage(fullMessage, 'FATAL');
    return Promise.reject(err);
  },
);

export { api };
